module.exports = __webpack_public_path__ + "static/media/Pljeskavica.e26c90d4.png";